import { Button } from "./ui/button";
import { openEnrollDialog } from "../hooks/useEnroll";
import { ArrowRight, Check } from "lucide-react";
import { useContent } from "../contexts/ContentContext";
import { Icon } from "./About";

export default function Courses() {
  const { content } = useContent();
  const c = content?.courses || {};
  if (c.enabled === false) return null;
  const items = c.items || [];
  const ctaLabel = c.cta_label || "Enroll Now";

  return (
    <section id="courses" className="py-20 lg:py-28 bg-secondary/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="overline">{c.eyebrow}</div>
            <h2 className="font-display mt-3 text-3xl lg:text-4xl font-medium tracking-tight">
              {c.heading}
            </h2>
            <p className="mt-4 text-muted-foreground leading-relaxed">{c.subheading}</p>
          </div>
          <Button
            data-testid="courses-enroll-btn"
            onClick={openEnrollDialog}
            className="bg-primary text-white hover:bg-[#059669] rounded-md h-11 px-6 w-fit"
          >
            Talk to a counsellor
          </Button>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => (
            <div
              key={c.id}
              data-testid={`course-card-${c.id}`}
              className="group relative p-7 rounded-2xl bg-white border border-border hover:-translate-y-1 hover:shadow-xl hover:border-primary/30 transition-all flex flex-col"
            >
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                  <Icon name={c.icon} className="h-5 w-5" />
                </div>
                <span className="text-xs uppercase tracking-widest text-muted-foreground">{c.duration}</span>
              </div>
              <div className="mt-6">
                <div className="overline text-accent">{c.short}</div>
                <h3 className="font-display mt-1 text-xl lg:text-2xl font-medium tracking-tight">{c.title}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{c.desc}</p>
              </div>

              {(c.bullets || []).filter(Boolean).length > 0 && (
                <ul className="mt-5 space-y-2.5 border-t border-border pt-5">
                  {(c.bullets || []).filter(Boolean).slice(0, 5).map((b, i) => (
                    <li
                      key={i}
                      data-testid={`course-${c.id}-bullet-${i}`}
                      className="flex items-start gap-2.5 text-sm text-foreground/80 leading-snug"
                    >
                      <span className="mt-0.5 h-4 w-4 rounded-full bg-primary/10 text-primary flex items-center justify-center shrink-0">
                        <Check className="h-2.5 w-2.5" strokeWidth={3} />
                      </span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}

              <div className="mt-auto pt-6">
                <Button
                  onClick={openEnrollDialog}
                  data-testid={`course-enroll-${c.id}`}
                  className="w-full h-11 bg-primary text-white hover:bg-[#059669] rounded-md text-sm font-medium"
                >
                  {c.cta_label || ctaLabel}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>
              {c.featured && (
                <div className="absolute top-5 right-5 bg-accent text-white text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full">
                  Most Joined
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
